import React from 'react';
import { WebsiteDesignProps } from './types';
import { Utensils, Bed, Wine } from 'lucide-react';
import { Button } from "@/components/ui/button";

const HospitalitySchool: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Grand Hospitality Academy";

    return (
        <div className="bg-[#f8f6f3] min-h-screen font-serif text-[#2c2c2c]">
            <nav className="bg-white border-b border-[#e5e0d8] px-12 py-6 flex justify-between items-center">
                <div className="flex flex-col items-start">
                    <span className="text-2xl font-light tracking-wide text-[#8b6914]">{schoolName}</span>
                    <span className="text-[10px] font-sans uppercase tracking-[0.3em] text-gray-400">Swiss Excellence</span>
                </div>
                <div className="hidden md:flex gap-10 text-sm font-sans uppercase tracking-widest text-gray-500">
                    <a href="#" className="hover:text-[#8b6914] transition-colors">Programs</a>
                    <a href="#" className="hover:text-[#8b6914] transition-colors">Campus</a>
                    <a href="#" className="hover:text-[#8b6914] transition-colors">Placement</a>
                </div>
                <Button className="bg-[#8b6914] text-white hover:bg-[#705210] font-sans uppercase text-xs tracking-widest rounded-none px-6">
                    Inquire
                </Button>
            </nav>

            <header className="relative">
                <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="p-12 md:p-20 flex flex-col justify-center">
                        <span className="text-[#8b6914] uppercase tracking-[0.3em] text-xs font-sans mb-6">
                            World-Renowned Training
                        </span>
                        <h1 className="text-5xl md:text-6xl font-light leading-tight mb-8">
                            The Art of <br/> <em>Hospitality.</em>
                        </h1>
                        <p className="text-lg text-gray-600 mb-10 max-w-md font-sans leading-relaxed">
                            Excellence is in the details. Learn to create unforgettable guest experiences at the world's premier hotel school.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-[#2c2c2c] text-white hover:bg-black font-sans uppercase tracking-widest text-xs px-8 py-6 rounded-none">
                                View Programs
                            </Button>
                        </div>
                    </div>
                    <div className="relative h-[500px] md:h-auto">
                        <img 
                            src="https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop" 
                            className="w-full h-full object-cover" 
                            alt="Hotel" 
                        />
                    </div>
                </div>
            </header>

            <section className="bg-[#2c2c2c] text-white py-20">
                <div className="container mx-auto px-12 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
                    {[
                        { icon: Bed, title: "Hotel Management" },
                        { icon: Utensils, title: "Culinary Arts" },
                        { icon: Wine, title: "Event Planning" },
                    ].map((item, i) => (
                        <div key={i} className="group cursor-pointer">
                            <div className="w-20 h-20 mx-auto border border-[#8b6914] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#8b6914] transition-colors">
                                <item.icon className="text-[#8b6914] group-hover:text-white transition-colors" size={28} strokeWidth={1} />
                            </div>
                            <h3 className="text-xl font-light tracking-wide">{item.title}</h3>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default HospitalitySchool;
